export const tool = {
  name: 'scene-instructions',
  description:
    'Update scene instructions, including descriptions of the setting and specific guidance for character behavior, dialogue, and actions. The instructions must include a paragraph starting with "Pretend to be...".',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      instructions: {
        type: 'string',
        description:
          'Full instructions for the scene, starting with a description of the setting and context. Include a paragraph that begins with "Pretend to be..." to define the character’s role.',
      },
      message: {
        type: 'string',
        description: 'Message returned after the instructions are applied.',
        default: 'Instructions added to the scene',
      },
    },
    required: ['instructions', 'message'],
  },
};
